export default "__VITE_ASSET__BjNGbHdi__"